webpackJsonp([35783957827783],{

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Sample3 = exports.Sample2 = exports.unlimited = exports.slack = exports.analytics = exports.editMessages = exports.autoMessages = exports.customizable = exports.easyInstall = exports.contactList = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactList = exports.contactList = function contactList(_ref) {
	  var style = _ref.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "99px",
	      height: "87px",
	      viewBox: "0 0 99 87",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        {
	          id: "Landing-Page-Copy",
	          transform: "translate(-341.000000, -1897.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Feature-Set", transform: "translate(258.000000, 1753.000000)" },
	          _react2.default.createElement(
	            "g",
	            {
	              id: "Contact-List---Feature-Set",
	              transform: "translate(83.000000, 141.000000)" },
	            _react2.default.createElement(
	              "g",
	              { id: "Group-30", transform: "translate(0.000000, 3.000000)" },
	              _react2.default.createElement("path", {
	                d: "M25.0645741,5.43917134 L27.9525354,4.625 L27.9525354,4.625 C41.0010932,0.946362859 54.8114509,0.93782051 67.8645495,4.60031256 L71.0102679,5.48295116 L71.0102679,5.48295116 C81.582847,8.44944884 89.8885386,16.6418119 93,27.1726402 L93.0258856,27.2602507 L93.0258856,27.2602507 C96.2722096,38.2475255 96.2632181,49.9403711 93,60.9226402 L93,60.9226402 L93,60.9226402 C89.8879801,71.3960558 81.6173858,79.5386618 71.0967123,82.4869721 L67.7942257,83.4124599 L67.7942257,83.4124599 C54.7548943,87.0665981 40.9603379,87.0536362 27.9278967,83.375 L24.8136814,82.4959579 L24.8136814,82.4959579 C14.3436989,79.5406208 6.11353066,71.4341412 3,61.0101076 L3,61.0101076 L3,61.0101076 C-0.263211178,50.0849468 -0.288590526,38.4479633 2.926936,27.5086729 L3,27.2601076 L3,27.2601076 C6.11138763,16.6750999 14.4456731,8.4328419 25.0645741,5.43917134 Z",
	                id: "Rectangle-19-Copy-18",
	                fill: "#B6BFF3"
	              }),
	              _react2.default.createElement("path", {
	                d: "M28.3359163,5.40165426 C18.0481585,8.30196926 9.97377203,16.2871981 6.95941088,26.5421196 L6.88634688,26.7906849 C3.72535777,37.5444378 3.75030667,48.9840505 6.95817167,59.7239135 C9.97371351,69.8198827 17.9448625,77.6712357 28.0853344,80.5335626 L31.1995497,81.4126047 C44.0549737,85.0412747 57.6621612,85.0540605 70.5243818,81.4495558 L73.8268684,80.524068 C84.016726,77.6684655 92.0272568,69.7818985 95.0414212,59.6378127 C98.2495601,48.840911 98.2583999,37.3454265 95.0668699,26.5436036 L95.0409843,26.4559931 C92.0269945,16.2550602 83.9814922,8.3193363 73.7401165,5.44576902 L70.5943981,4.56313042 C57.7183933,0.950328074 44.0954033,0.958754527 31.2238777,4.58748292 L28.3359163,5.40165426 Z",
	                id: "Rectangle-19-Copy-19",
	                stroke: "#222232",
	                strokeWidth: "2"
	              }),
	              _react2.default.createElement(
	                "g",
	                { id: "Group-29", transform: "translate(29.000000, 19.000000)" },
	                _react2.default.createElement("rect", {
	                  id: "Rectangle-46",
	                  fill: "#F7F7F9",
	                  x: "0",
	                  y: "1",
	                  width: "38",
	                  height: "20",
	                  rx: "3"
	                }),
	                _react2.default.createElement("path", {
	                  d: "M5,6.99620141 L19.2008109,15.791534 L19.2008109,15.791534 C19.8487274,16.1928238 20.6683959,16.1910037 21.3145239,15.7868405 L34.2876306,7.67195665",
	                  id: "Path-20-Copy",
	                  stroke: "#9192C5",
	                  strokeLinecap: "round",
	                  strokeLinejoin: "round",
	                  transform: "translate(19.643815, 11.543719) scale(1, -1) translate(-19.643815, -11.543719) "
	                }),
	                _react2.default.createElement("polygon", {
	                  id: "Path-20",
	                  fill: "#D6D6E0",
	                  points: "2 1 20.2030714 12 38 1"
	                }),
	                _react2.default.createElement("path", {
	                  d: "M8.50250442,5.08816214 L19.2164965,11.5927557 L19.2164965,11.5927557 C19.8567472,11.9814596 20.6605226,11.9798422 21.2992038,11.5885648 L36.9524628,1.99885639",
	                  id: "Path-20",
	                  stroke: "#222232",
	                  strokeLinecap: "round",
	                  strokeLinejoin: "round"
	                }),
	                _react2.default.createElement("rect", {
	                  id: "Rectangle-46",
	                  stroke: "#222232",
	                  strokeWidth: "2",
	                  x: "2",
	                  y: "1",
	                  width: "36",
	                  height: "18",
	                  rx: "3"
	                })
	              ),
	              _react2.default.createElement(
	                "g",
	                { id: "Group-29", transform: "translate(46.000000, 33.000000)" },
	                _react2.default.createElement("rect", {
	                  id: "Rectangle-46",
	                  fill: "#F7F7F9",
	                  x: "0",
	                  y: "1",
	                  width: "38",
	                  height: "20",
	                  rx: "3"
	                }),
	                _react2.default.createElement("path", {
	                  d: "M5,6.99620141 L19.2008109,15.791534 L19.2008109,15.791534 C19.8487274,16.1928238 20.6683959,16.1910037 21.3145239,15.7868405 L34.2876306,7.67195665",
	                  id: "Path-20-Copy",
	                  stroke: "#9192C5",
	                  strokeLinecap: "round",
	                  strokeLinejoin: "round",
	                  transform: "translate(19.643815, 11.543719) scale(1, -1) translate(-19.643815, -11.543719) "
	                }),
	                _react2.default.createElement("polygon", {
	                  id: "Path-20",
	                  fill: "#D6D6E0",
	                  points: "2 1 20.2030714 12 38 1"
	                }),
	                _react2.default.createElement("path", {
	                  d: "M7.73975993,4.53278256 L19.2144213,11.5837929 L19.2144213,11.5837929 C19.8554502,11.9776957 20.6633077,11.978514 21.3051333,11.5859106 L36.9290487,2.02879332",
	                  id: "Path-20",
	                  stroke: "#222232",
	                  strokeLinecap: "round",
	                  strokeLinejoin: "round"
	                }),
	                _react2.default.createElement("rect", {
	                  id: "Rectangle-46",
	                  stroke: "#222232",
	                  strokeWidth: "2",
	                  x: "2",
	                  y: "1",
	                  width: "36",
	                  height: "18",
	                  rx: "3"
	                })
	              ),
	              _react2.default.createElement(
	                "g",
	                { id: "Group-29", transform: "translate(23.000000, 44.000000)" },
	                _react2.default.createElement("rect", {
	                  id: "Rectangle-46",
	                  fill: "#F7F7F9",
	                  x: "0",
	                  y: "1",
	                  width: "38",
	                  height: "20",
	                  rx: "3"
	                }),
	                _react2.default.createElement("path", {
	                  d: "M5,6.99620141 L19.2008109,15.791534 L19.2008109,15.791534 C19.8487274,16.1928238 20.6683959,16.1910037 21.3145239,15.7868405 L34.2876306,7.67195665",
	                  id: "Path-20-Copy",
	                  stroke: "#9192C5",
	                  strokeLinecap: "round",
	                  strokeLinejoin: "round",
	                  transform: "translate(19.643815, 11.543719) scale(1, -1) translate(-19.643815, -11.543719) "
	                }),
	                _react2.default.createElement("polygon", {
	                  id: "Path-20",
	                  fill: "#D6D6E0",
	                  points: "2 1 20.2030714 12 38 1"
	                }),
	                _react2.default.createElement("path", {
	                  d: "M8.58458475,5.12960041 L19.207944,11.5868076 L19.207944,11.5868076 C19.8526403,11.978674 20.6629903,11.9744053 21.3035225,11.5757686 L36.6980868,1.99492494",
	                  id: "Path-20",
	                  stroke: "#222232",
	                  strokeLinecap: "round",
	                  strokeLinejoin: "round"
	                }),
	                _react2.default.createElement("rect", {
	                  id: "Rectangle-46",
	                  stroke: "#222232",
	                  strokeWidth: "2",
	                  x: "2",
	                  y: "1",
	                  width: "36",
	                  height: "18",
	                  rx: "3"
	                })
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	var easyInstall = exports.easyInstall = function easyInstall(_ref2) {
	  var style = _ref2.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "99px",
	      height: "87px",
	      viewBox: "0 0 99 87",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        {
	          id: "Landing-Page-Copy",
	          transform: "translate(-340.000000, -2030.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Feature-Set", transform: "translate(258.000000, 1753.000000)" },
	          _react2.default.createElement(
	            "g",
	            {
	              id: "Easy-Install---Feature-Set",
	              transform: "translate(82.000000, 275.000000)" },
	            _react2.default.createElement(
	              "g",
	              { id: "Group-31", transform: "translate(0.000000, 2.000000)" },
	              _react2.default.createElement("path", {
	                d: "M25.0645741,5.43917134 L27.9525354,4.625 L27.9525354,4.625 C41.0010932,0.946362859 54.8114509,0.93782051 67.8645495,4.60031256 L71.0102679,5.48295116 L71.0102679,5.48295116 C81.582847,8.44944884 89.8885386,16.6418119 93,27.1726402 L93.0258856,27.2602507 L93.0258856,27.2602507 C96.2722096,38.2475255 96.2632181,49.9403711 93,60.9226402 L93,60.9226402 L93,60.9226402 C89.8879801,71.3960558 81.6173858,79.5386618 71.0967123,82.4869721 L67.7942257,83.4124599 L67.7942257,83.4124599 C54.7548943,87.0665981 40.9603379,87.0536362 27.9278967,83.375 L24.8136814,82.4959579 L24.8136814,82.4959579 C14.3436989,79.5406208 6.11353066,71.4341412 3,61.0101076 L3,61.0101076 L3,61.0101076 C-0.263211178,50.0849468 -0.288590526,38.4479633 2.926936,27.5086729 L3,27.2601076 L3,27.2601076 C6.11138763,16.6750999 14.4456731,8.4328419 25.0645741,5.43917134 Z",
	                id: "Rectangle-19-Copy-9",
	                fill: "#B6BFF3"
	              }),
	              _react2.default.createElement("path", {
	                d: "M28.3359163,5.40165426 C18.0481585,8.30196926 9.97377203,16.2871981 6.95941088,26.5421196 L6.88634688,26.7906849 C3.72535777,37.5444378 3.75030667,48.9840505 6.95817167,59.7239135 C9.97371351,69.8198827 17.9448625,77.6712357 28.0853344,80.5335626 L31.1995497,81.4126047 C44.0549737,85.0412747 57.6621612,85.0540605 70.5243818,81.4495558 L73.8268684,80.524068 C84.016726,77.6684655 92.0272568,69.7818985 95.0414212,59.6378127 C98.2495601,48.840911 98.2583999,37.3454265 95.0668699,26.5436036 L95.0409843,26.4559931 C92.0269945,16.2550602 83.9814922,8.3193363 73.7401165,5.44576902 L70.5943981,4.56313042 C57.7183933,0.950328074 44.0954033,0.958754527 31.2238777,4.58748292 L28.3359163,5.40165426 Z",
	                id: "Rectangle-19-Copy-10",
	                stroke: "#222232",
	                strokeWidth: "2"
	              }),
	              _react2.default.createElement("path", {
	                d: "M25.391114,42.2440523 L23.6079109,42.8670991 L24.6606453,43.2967866 L37.0117188,48.8183691 L37.0117188,53.8278222 L18.4086921,45.5189894 L18.4086921,40.224521 L37.0117188,32.0148441 L37.0117188,37.7640632 L25.391114,42.2440523 Z M46.0390625,58.6855469 L40.4101562,58.6855469 L54.6282403,24.71875 L60.2786309,24.71875 L46.0390625,58.6855469 Z M63.8233095,37.9230472 L63.8233095,32.0148441 L81.9199219,40.0800781 L81.9199219,44.8925781 L63.8233095,53.2953264 L63.8233095,47.0968754 L74.3359375,43.0019531 L75.9472656,42.5078125 L75.0449219,42.1425781 L63.8233095,37.9230472 Z",
	                id: "<-/->",
	                fill: "#F7F7F9"
	              }),
	              _react2.default.createElement("path", {
	                d: "M22.4882812,41.90625 L37.9785156,48.3515625 L37.9785156,51.0585938 L19.5664062,42.9160156 L19.5664062,40.8535156 L37.9785156,32.7324219 L37.9785156,35.4179688 L22.4882812,41.90625 Z M47.2089844,58.6855469 L44.8027344,58.6855469 L57.8652344,24.71875 L60.2714844,24.71875 L47.2089844,58.6855469 Z M81.3398438,41.8203125 L65.5488281,35.3320312 L65.5488281,32.6894531 L84.3261719,40.8105469 L84.3261719,42.8730469 L65.5488281,51.015625 L65.5488281,48.3730469 L81.3398438,41.8203125 Z",
	                id: "<-/->",
	                fill: "#000000"
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	var customizable = exports.customizable = function customizable(_ref3) {
	  var style = _ref3.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "99px",
	      height: "87px",
	      viewBox: "0 0 99 87",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        {
	          id: "Landing-Page-Copy",
	          transform: "translate(-340.000000, -2161.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Feature-Set", transform: "translate(258.000000, 1753.000000)" },
	          _react2.default.createElement(
	            "g",
	            {
	              id: "Customizable---Feature-Set",
	              transform: "translate(82.000000, 406.000000)" },
	            _react2.default.createElement(
	              "g",
	              { id: "Group-32", transform: "translate(0.000000, 2.000000)" },
	              _react2.default.createElement("path", {
	                d: "M25.0645741,5.43917134 L27.9525354,4.625 L27.9525354,4.625 C41.0010932,0.946362859 54.8114509,0.93782051 67.8645495,4.60031256 L71.0102679,5.48295116 L71.0102679,5.48295116 C81.582847,8.44944884 89.8885386,16.6418119 93,27.1726402 L93.0258856,27.2602507 L93.0258856,27.2602507 C96.2722096,38.2475255 96.2632181,49.9403711 93,60.9226402 L93,60.9226402 L93,60.9226402 C89.8879801,71.3960558 81.6173858,79.5386618 71.0967123,82.4869721 L67.7942257,83.4124599 L67.7942257,83.4124599 C54.7548943,87.0665981 40.9603379,87.0536362 27.9278967,83.375 L24.8136814,82.4959579 L24.8136814,82.4959579 C14.3436989,79.5406208 6.11353066,71.4341412 3,61.0101076 L3,61.0101076 L3,61.0101076 C-0.263211178,50.0849468 -0.288590526,38.4479633 2.926936,27.5086729 L3,27.2601076 L3,27.2601076 C6.11138763,16.6750999 14.4456731,8.4328419 25.0645741,5.43917134 Z",
	                id: "Rectangle-19-Copy-20",
	                fill: "#B6BFF3"
	              }),
	              _react2.default.createElement("path", {
	                d: "M28.3359163,5.40165426 C18.0481585,8.30196926 9.97377203,16.2871981 6.95941088,26.5421196 L6.88634688,26.7906849 C3.72535777,37.5444378 3.75030667,48.9840505 6.95817167,59.7239135 C9.97371351,69.8198827 17.9448625,77.6712357 28.0853344,80.5335626 L31.1995497,81.4126047 C44.0549737,85.0412747 57.6621612,85.0540605 70.5243818,81.4495558 L73.8268684,80.524068 C84.016726,77.6684655 92.0272568,69.7818985 95.0414212,59.6378127 C98.2495601,48.840911 98.2583999,37.3454265 95.0668699,26.5436036 L95.0409843,26.4559931 C92.0269945,16.2550602 83.9814922,8.3193363 73.7401165,5.44576902 L70.5943981,4.56313042 C57.7183933,0.950328074 44.0954033,0.958754527 31.2238777,4.58748292 L28.3359163,5.40165426 Z",
	                id: "Rectangle-19-Copy-21",
	                stroke: "#222232",
	                strokeWidth: "2"
	              }),
	              _react2.default.createElement(
	                "g",
	                {
	                  id: "Customizable---Feature-Set",
	                  transform: "translate(28.000000, 28.000000)",
	                  stroke: "#FFFFFF",
	                  strokeWidth: "3",
	                  strokeLinecap: "round",
	                  strokeLinejoin: "round" },
	                _react2.default.createElement("path", { d: "M0,1.5 L50,1.5", id: "Line-12-Copy-3" })
	              ),
	              _react2.default.createElement("path", {
	                d: "M28,41.5 L78,41.5",
	                id: "Line-12-Copy-4",
	                stroke: "#FFFFFF",
	                strokeWidth: "3",
	                strokeLinecap: "round",
	                strokeLinejoin: "round"
	              }),
	              _react2.default.createElement("path", {
	                d: "M28,53.5 L78,53.5",
	                id: "Line-12-Copy-5",
	                stroke: "#FFFFFF",
	                strokeWidth: "3",
	                strokeLinecap: "round",
	                strokeLinejoin: "round"
	              }),
	              _react2.default.createElement("path", {
	                d: "M71.5,54.5 L52.5,54.5",
	                id: "Line-13-Copy-3",
	                stroke: "#222232",
	                strokeLinecap: "round"
	              }),
	              _react2.default.createElement("path", {
	                d: "M48.5,42.5 L29.5,42.5",
	                id: "Line-13-Copy-4",
	                stroke: "#222232",
	                strokeLinecap: "round"
	              }),
	              _react2.default.createElement("path", {
	                d: "M49.5,30.5 L30.5,30.5",
	                id: "Line-13-Copy-5",
	                stroke: "#222232",
	                strokeLinecap: "round"
	              }),
	              _react2.default.createElement("circle", {
	                id: "Oval-13-Copy-3",
	                fill: "#F7F7F9",
	                cx: "44",
	                cy: "29",
	                r: "4"
	              }),
	              _react2.default.createElement("circle", {
	                id: "Oval-13-Copy-4",
	                fill: "#F7F7F9",
	                cx: "36",
	                cy: "41",
	                r: "4"
	              }),
	              _react2.default.createElement("circle", {
	                id: "Oval-13-Copy-5",
	                fill: "#F7F7F9",
	                cx: "70",
	                cy: "53",
	                r: "4"
	              }),
	              _react2.default.createElement("circle", {
	                id: "Oval-13-Copy-6",
	                fill: "#9192C5",
	                cx: "42",
	                cy: "30",
	                r: "4"
	              }),
	              _react2.default.createElement("circle", {
	                id: "Oval-13-Copy-7",
	                fill: "#9192C5",
	                cx: "34",
	                cy: "42",
	                r: "4"
	              }),
	              _react2.default.createElement("circle", {
	                id: "Oval-13-Copy-8",
	                fill: "#9192C5",
	                cx: "68",
	                cy: "54",
	                r: "4"
	              }),
	              _react2.default.createElement("circle", {
	                id: "Oval-13-Copy-9",
	                stroke: "#222232",
	                strokeWidth: "2",
	                cx: "44",
	                cy: "29",
	                r: "4"
	              }),
	              _react2.default.createElement("circle", {
	                id: "Oval-13-Copy-10",
	                stroke: "#222232",
	                strokeWidth: "2",
	                cx: "36",
	                cy: "41",
	                r: "4"
	              }),
	              _react2.default.createElement("circle", {
	                id: "Oval-13-Copy-11",
	                stroke: "#222232",
	                strokeWidth: "2",
	                cx: "70",
	                cy: "53",
	                r: "4"
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	var autoMessages = exports.autoMessages = function autoMessages(_ref4) {
	  var style = _ref4.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "99px",
	      height: "87px",
	      viewBox: "0 0 99 87",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        {
	          id: "Landing-Page-Copy",
	          transform: "translate(-855.000000, -1899.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Feature-Set", transform: "translate(258.000000, 1753.000000)" },
	          _react2.default.createElement(
	            "g",
	            {
	              id: "Auto-Message---Feature-Set",
	              transform: "translate(597.000000, 141.000000)" },
	            _react2.default.createElement(
	              "g",
	              { id: "Group-32", transform: "translate(0.000000, 5.000000)" },
	              _react2.default.createElement("path", {
	                d: "M25.0645741,5.43917134 L27.9525354,4.625 L27.9525354,4.625 C41.0010932,0.946362859 54.8114509,0.93782051 67.8645495,4.60031256 L71.0102679,5.48295116 L71.0102679,5.48295116 C81.582847,8.44944884 89.8885386,16.6418119 93,27.1726402 L93.0258856,27.2602507 L93.0258856,27.2602507 C96.2722096,38.2475255 96.2632181,49.9403711 93,60.9226402 L93,60.9226402 L93,60.9226402 C89.8879801,71.3960558 81.6173858,79.5386618 71.0967123,82.4869721 L67.7942257,83.4124599 L67.7942257,83.4124599 C54.7548943,87.0665981 40.9603379,87.0536362 27.9278967,83.375 L24.8136814,82.4959579 L24.8136814,82.4959579 C14.3436989,79.5406208 6.11353066,71.4341412 3,61.0101076 L3,61.0101076 L3,61.0101076 C-0.263211178,50.0849468 -0.288590526,38.4479633 2.926936,27.5086729 L3,27.2601076 L3,27.2601076 C6.11138763,16.6750999 14.4456731,8.4328419 25.0645741,5.43917134 Z",
	                id: "Rectangle-19-Copy-20",
	                fill: "#B6BFF3"
	              }),
	              _react2.default.createElement("path", {
	                d: "M28.3359163,5.40165426 C18.0481585,8.30196926 9.97377203,16.2871981 6.95941088,26.5421196 L6.88634688,26.7906849 C3.72535777,37.5444378 3.75030667,48.9840505 6.95817167,59.7239135 C9.97371351,69.8198827 17.9448625,77.6712357 28.0853344,80.5335626 L31.1995497,81.4126047 C44.0549737,85.0412747 57.6621612,85.0540605 70.5243818,81.4495558 L73.8268684,80.524068 C84.016726,77.6684655 92.0272568,69.7818985 95.0414212,59.6378127 C98.2495601,48.840911 98.2583999,37.3454265 95.0668699,26.5436036 L95.0409843,26.4559931 C92.0269945,16.2550602 83.9814922,8.3193363 73.7401165,5.44576902 L70.5943981,4.56313042 C57.7183933,0.950328074 44.0954033,0.958754527 31.2238777,4.58748292 L28.3359163,5.40165426 Z",
	                id: "Rectangle-19-Copy-21",
	                stroke: "#222232",
	                strokeWidth: "2"
	              }),
	              _react2.default.createElement(
	                "g",
	                { id: "Group-22-Copy", transform: "translate(18.000000, 21.000000)" },
	                _react2.default.createElement("ellipse", {
	                  id: "Oval-11",
	                  fill: "#EBECEF",
	                  cx: "20.5",
	                  cy: "19",
	                  rx: "20.5",
	                  ry: "18"
	                }),
	                _react2.default.createElement("path", {
	                  d: "M11.9995947,40 L18.022421,36.0761035 C20.058443,36.6878675 22.2363762,37.0191304 24.5,37.0191304 C35.8218374,37.0191304 45,28.7321158 45,18.5095652 C45,8.28701461 35.8218374,0 24.5,0 C22.9753566,0 21.4895874,0.150279875 20.059871,0.435329014 C16.0319188,1.2384004 12.44887,3.11116611 9.69486511,5.70678375 C8.76116213,6.58678796 7.92275315,7.54988 7.19460818,8.58254336 C5.17184446,11.4512496 4,14.8568452 4,18.5095652 C4,24.0337041 6.68019502,28.9926303 10.9305199,32.3840599",
	                  id: "Combined-Shape",
	                  stroke: "#222232",
	                  strokeWidth: "2",
	                  strokeLinecap: "round",
	                  strokeLinejoin: "round"
	                }),
	                _react2.default.createElement("ellipse", {
	                  id: "Oval-11",
	                  fill: "#FFFFFF",
	                  cx: "39.5",
	                  cy: "25",
	                  rx: "20.5",
	                  ry: "18"
	                }),
	                _react2.default.createElement("path", {
	                  d: "M29.9995947,47 L36.022421,43.0761035 C38.058443,43.6878675 40.2363762,44.0191304 42.5,44.0191304 C53.8218374,44.0191304 63,35.7321158 63,25.5095652 C63,15.2870146 53.8218374,7 42.5,7 C40.9753566,7 39.4895874,7.15027988 38.059871,7.43532901 C34.0319188,8.2384004 30.44887,10.1111661 27.6948651,12.7067838 C26.7611621,13.586788 25.9227532,14.54988 25.1946082,15.5825434 C23.1718445,18.4512496 22,21.8568452 22,25.5095652 C22,31.0337041 24.680195,35.9926303 28.9305199,39.3840599",
	                  id: "Combined-Shape-Copy-2",
	                  stroke: "#222232",
	                  strokeWidth: "2",
	                  strokeLinecap: "round",
	                  strokeLinejoin: "round",
	                  transform: "translate(42.500000, 27.000000) scale(-1, 1) translate(-42.500000, -27.000000) "
	                })
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	var editMessages = exports.editMessages = function editMessages(_ref5) {
	  var style = _ref5.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "99px",
	      height: "87px",
	      viewBox: "0 0 99 87",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        {
	          id: "Landing-Page-Copy",
	          transform: "translate(-857.000000, -2030.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Feature-Set", transform: "translate(258.000000, 1753.000000)" },
	          _react2.default.createElement(
	            "g",
	            {
	              id: "Message-Editing---Feature-Set",
	              transform: "translate(599.000000, 275.000000)" },
	            _react2.default.createElement(
	              "g",
	              { id: "Group-32", transform: "translate(0.000000, 2.000000)" },
	              _react2.default.createElement("path", {
	                d: "M25.0645741,5.43917134 L27.9525354,4.625 L27.9525354,4.625 C41.0010932,0.946362859 54.8114509,0.93782051 67.8645495,4.60031256 L71.0102679,5.48295116 L71.0102679,5.48295116 C81.582847,8.44944884 89.8885386,16.6418119 93,27.1726402 L93.0258856,27.2602507 L93.0258856,27.2602507 C96.2722096,38.2475255 96.2632181,49.9403711 93,60.9226402 L93,60.9226402 L93,60.9226402 C89.8879801,71.3960558 81.6173858,79.5386618 71.0967123,82.4869721 L67.7942257,83.4124599 L67.7942257,83.4124599 C54.7548943,87.0665981 40.9603379,87.0536362 27.9278967,83.375 L24.8136814,82.4959579 L24.8136814,82.4959579 C14.3436989,79.5406208 6.11353066,71.4341412 3,61.0101076 L3,61.0101076 L3,61.0101076 C-0.263211178,50.0849468 -0.288590526,38.4479633 2.926936,27.5086729 L3,27.2601076 L3,27.2601076 C6.11138763,16.6750999 14.4456731,8.4328419 25.0645741,5.43917134 Z",
	                id: "Rectangle-19-Copy-20",
	                fill: "#B6BFF3"
	              }),
	              _react2.default.createElement("path", {
	                d: "M28.3359163,5.40165426 C18.0481585,8.30196926 9.97377203,16.2871981 6.95941088,26.5421196 L6.88634688,26.7906849 C3.72535777,37.5444378 3.75030667,48.9840505 6.95817167,59.7239135 C9.97371351,69.8198827 17.9448625,77.6712357 28.0853344,80.5335626 L31.1995497,81.4126047 C44.0549737,85.0412747 57.6621612,85.0540605 70.5243818,81.4495558 L73.8268684,80.524068 C84.016726,77.6684655 92.0272568,69.7818985 95.0414212,59.6378127 C98.2495601,48.840911 98.2583999,37.3454265 95.0668699,26.5436036 L95.0409843,26.4559931 C92.0269945,16.2550602 83.9814922,8.3193363 73.7401165,5.44576902 L70.5943981,4.56313042 C57.7183933,0.950328074 44.0954033,0.958754527 31.2238777,4.58748292 L28.3359163,5.40165426 Z",
	                id: "Rectangle-19-Copy-21",
	                stroke: "#222232",
	                strokeWidth: "2"
	              }),
	              _react2.default.createElement(
	                "g",
	                { id: "Group-22-Copy", transform: "translate(28.000000, 18.000000)" },
	                _react2.default.createElement("ellipse", {
	                  id: "Oval-11-Copy",
	                  fill: "#FFFFFF",
	                  cx: "20.5",
	                  cy: "26",
	                  rx: "20.5",
	                  ry: "18"
	                }),
	                _react2.default.createElement("path", {
	                  d: "M10.9995947,48 L17.022421,44.0761035 C19.058443,44.6878675 21.2363762,45.0191304 23.5,45.0191304 C34.8218374,45.0191304 44,36.7321158 44,26.5095652 C44,16.2870146 34.8218374,8 23.5,8 C21.9753566,8 20.4895874,8.15027988 19.059871,8.43532901 C15.0319188,9.2384004 11.44887,11.1111661 8.69486511,13.7067838 C7.76116213,14.586788 6.92275315,15.54988 6.19460818,16.5825434 C4.17184446,19.4512496 3,22.8568452 3,26.5095652 C3,32.0337041 5.68019502,36.9926303 9.93051993,40.3840599",
	                  id: "Combined-Shape-Copy-3",
	                  stroke: "#222232",
	                  strokeWidth: "2",
	                  strokeLinecap: "round",
	                  strokeLinejoin: "round",
	                  transform: "translate(23.500000, 28.000000) scale(-1, 1) translate(-23.500000, -28.000000) "
	                }),
	                _react2.default.createElement("path", {
	                  d: "M32.4767288,-0.221782976 L34.6019832,-0.39688284 L34.6019832,-0.39688284 C36.2532425,-0.532930207 37.7021408,0.695391721 37.8381881,2.34665097 C37.8413529,2.3850627 37.8437771,2.42353185 37.8454594,2.46203699 L38.6899618,21.7907998 L34.9235178,28.3564521 L34.9235178,28.3564521 C34.6487028,28.8355087 34.0375691,29.0010792 33.5585126,28.7262642 C33.41106,28.6416767 33.2876046,28.5208965 33.1998077,28.375332 L30.2978587,23.5639933 L30.2978587,23.5639933 C29.9218045,22.9405075 29.7230643,22.2262025 29.7230643,21.4980876 L29.7230643,2.76808638 L29.7230643,2.76808638 C29.7230643,1.20674101 30.9206559,-0.0935780198 32.4767288,-0.221782976 Z",
	                  id: "Rectangle-9",
	                  fill: "#9192C5",
	                  transform: "translate(34.206513, 14.225924) rotate(-315.000000) translate(-34.206513, -14.225924) "
	                }),
	                _react2.default.createElement(
	                  "g",
	                  {
	                    id: "pencil",
	                    transform: "translate(22.000000, 0.000000)",
	                    stroke: "#222232" },
	                  _react2.default.createElement(
	                    "g",
	                    {
	                      id: "Group-7-Copy",
	                      transform: "translate(13.849242, 13.849242) rotate(-225.000000) translate(-13.849242, -13.849242) translate(-1.150758, 9.849242)" },
	                    _react2.default.createElement("rect", {
	                      id: "Rectangle-19",
	                      strokeWidth: "2",
	                      x: "5.53713536",
	                      y: "1",
	                      width: "16.9047307",
	                      height: "5.56189227"
	                    }),
	                    _react2.default.createElement("path", {
	                      d: "M23.9675791,6.56189227 L28.4494334,3.91657194 C28.7524791,3.73770562 28.7525398,3.77965392 28.4525808,3.60266868 L24.0415131,1 L3.79858159,1 C2.25841341,1 1.01514008,2.24347728 1.01514008,3.78094613 C1.01514008,5.31395832 2.26352253,6.56189227 3.80038106,6.56189227 L23.9675791,6.56189227 Z",
	                      id: "Rectangle-19-Copy-2",
	                      strokeWidth: "2"
	                    })
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	var analytics = exports.analytics = function analytics(_ref6) {
	  var style = _ref6.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "98px",
	      height: "85px",
	      viewBox: "0 0 98 85",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "2", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        {
	          id: "Landing-Page-Copy",
	          transform: "translate(-856.000000, -2162.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Feature-Set", transform: "translate(258.000000, 1753.000000)" },
	          _react2.default.createElement(
	            "g",
	            {
	              id: "Analytics---Feature-Set",
	              transform: "translate(598.000000, 406.000000)" },
	            _react2.default.createElement(
	              "g",
	              { id: "Group-23", transform: "translate(0.000000, 3.000000)" },
	              _react2.default.createElement("path", {
	                d: "M24.4905599,4.58447451 L27.4417745,3.75596891 L27.4417745,3.75596891 C40.5033442,0.0891452598 54.3211933,0.0806289737 67.3872731,3.7313495 L70.5962402,4.62794914 L70.5962402,4.62794914 C81.1401053,7.57395173 89.4297989,15.732231 92.5438992,26.2276777 L92.5697889,26.3149337 L92.5697889,26.3149337 C95.8182862,37.2633383 95.8092903,48.9206435 92.5438992,59.8640212 L92.5438992,59.8640212 L92.5438992,59.8640212 C89.429237,70.3022582 81.1745416,78.410983 70.6824013,81.3389349 L67.3168622,82.2781272 L67.3168622,82.2781272 C54.2645817,85.9205156 40.4625522,85.9075932 27.4171151,82.2407705 L24.240531,81.3478935 L24.240531,81.3478935 C13.7988698,78.4129424 5.58444466,70.3402119 2.46827125,59.9511941 L2.46827125,59.9511941 L2.46827125,59.9511941 C-0.797112839,49.0647225 -0.822504615,37.4630716 2.39519539,26.5624109 L2.46827125,26.3148505 L2.46827125,26.3148505 C5.58229344,15.7654211 13.9005186,7.55745666 24.4905599,4.58447451 Z",
	                id: "Rectangle-19-Copy-16",
	                fill: "#B6BFF3"
	              }),
	              _react2.default.createElement("path", {
	                d: "M27.7608448,4.54725488 C17.5020342,7.42724943 9.44398265,15.3784888 6.42735945,25.597958 L6.3542836,25.8455184 C3.19155442,36.5599534 3.21651241,47.9634029 6.42611103,58.6638912 C9.4439219,68.7249779 17.3990573,76.5428913 27.5111257,79.3852002 L30.6877098,80.2780772 C43.5567917,83.8953298 57.1722379,83.9080774 70.0480707,80.3149288 L73.4136097,79.3757366 C83.5748535,76.5401251 91.5692159,68.6871297 94.5856493,58.5780893 C97.7955238,47.8207653 97.8043668,36.3616517 94.6110988,25.5993863 L94.5852091,25.5121303 C91.5689534,15.346449 83.5397207,7.44450158 73.3271423,4.59106195 L70.1181751,3.69446231 C57.2285263,0.0930373555 43.5972592,0.101438646 30.7120595,3.71874928 L27.7608448,4.54725488 Z",
	                id: "Rectangle-19-Copy-17",
	                stroke: "#222232",
	                strokeWidth: "2"
	              }),
	              _react2.default.createElement(
	                "g",
	                { id: "Group-28", transform: "translate(25.000000, 25.000000)" },
	                _react2.default.createElement("rect", {
	                  id: "Rectangle-45",
	                  fill: "#FFFFFF",
	                  x: "0",
	                  y: "3",
	                  width: "50",
	                  height: "30",
	                  rx: "3"
	                }),
	                _react2.default.createElement("path", {
	                  d: "M3.69324136,28.8950601 L9.11019346,19.3409746 L9.11019346,19.3409746 C9.65498621,18.3801028 10.8755685,18.0428041 11.8364403,18.5875968 C11.8411173,18.5902486 11.8457836,18.5929191 11.850439,18.5956085 L15.5241629,20.7178594 L15.5241629,20.7178594 C17.0468352,21.5974826 18.9654005,21.3794974 20.2519247,20.1806966 L26.0935078,14.7374293 L26.0935078,14.7374293 C26.6940211,14.1778628 27.5754617,14.0420176 28.3165859,14.3948147 L33.0555244,16.6506897 L33.0555244,16.6506897 C34.2818599,17.2344617 35.7206363,17.1560665 36.8762835,16.4425064 L48.9298034,9 L48.9298034,29.8814947 L48.9298034,29.8814947 C48.9298034,30.9860642 48.0343729,31.8814947 46.9298034,31.8814947 L5.43305368,31.8814947 L5.43305368,31.8814947 C4.32848418,31.8814947 3.43305368,30.9860642 3.43305368,29.8814947 C3.43305368,29.5357199 3.52269929,29.1958517 3.69324136,28.8950601 Z",
	                  id: "Path-4",
	                  fill: "#EBECEF"
	                }),
	                _react2.default.createElement("path", {
	                  d: "M2.91741078,30.2302125 L12.1588613,17.8788385 L12.1588613,17.8788385 C12.4207982,17.5287548 12.8798004,17.3894323 13.2921388,17.5348509 L20.1018015,19.9364007 L20.1018015,19.9364007 C20.8006688,20.1828688 21.5785318,20.0227064 22.1231842,19.520197 L28.9214226,13.2479787 L28.9214226,13.2479787 C29.2362683,12.9574945 29.7011647,12.8998146 30.0774523,13.1045497 L35.9705581,16.3109404 L35.9705581,16.3109404 C36.7187632,16.7180327 37.6427079,16.6065721 38.2726375,16.0332279 L46,9",
	                  id: "Path-4",
	                  stroke: "#9192C5",
	                  strokeWidth: "2",
	                  strokeLinecap: "round"
	                }),
	                _react2.default.createElement("path", {
	                  d: "M2,8 L2,28.3057804 L2,28.3057804 C2,29.9626346 3.34314575,31.3057804 5,31.3057804 L42.9338268,31.3057804",
	                  id: "Path-19",
	                  stroke: "#222232",
	                  strokeWidth: "2",
	                  strokeLinecap: "round"
	                }),
	                _react2.default.createElement("path", {
	                  d: "M38.8107389,-3.55271368e-15 L38.8107389,12.6460872 L38.8107389,12.6460872 C38.8107389,14.3029415 40.1538847,15.6460872 41.8107389,15.6460872 L52.9338268,15.6460872",
	                  id: "Path-19-Copy",
	                  stroke: "#222232",
	                  strokeWidth: "2",
	                  strokeLinecap: "round",
	                  transform: "translate(45.872283, 7.823044) scale(-1, -1) translate(-45.872283, -7.823044) "
	                })
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	var slack = exports.slack = function slack(_ref7) {
	  var style = _ref7.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "99px",
	      height: "87px",
	      viewBox: "0 0 99 87",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { id: "icon-system", transform: "translate(-598.000000, -511.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Group-31-Copy", transform: "translate(598.000000, 511.000000)" },
	          _react2.default.createElement(
	            "g",
	            { id: "Group-42" },
	            _react2.default.createElement("path", {
	              d: "M25.0645741,5.43917134 L27.9525354,4.625 L27.9525354,4.625 C41.0010932,0.946362859 54.8114509,0.93782051 67.8645495,4.60031256 L71.0102679,5.48295116 L71.0102679,5.48295116 C81.582847,8.44944884 89.8885386,16.6418119 93,27.1726402 L93.0258856,27.2602507 L93.0258856,27.2602507 C96.2722096,38.2475255 96.2632181,49.9403711 93,60.9226402 L93,60.9226402 L93,60.9226402 C89.8879801,71.3960558 81.6173858,79.5386618 71.0967123,82.4869721 L67.7942257,83.4124599 L67.7942257,83.4124599 C54.7548943,87.0665981 40.9603379,87.0536362 27.9278967,83.375 L24.8136814,82.4959579 L24.8136814,82.4959579 C14.3436989,79.5406208 6.11353066,71.4341412 3,61.0101076 L3,61.0101076 L3,61.0101076 C-0.263211178,50.0849468 -0.288590526,38.4479633 2.926936,27.5086729 L3,27.2601076 L3,27.2601076 C6.11138763,16.6750999 14.4456731,8.4328419 25.0645741,5.43917134 Z",
	              id: "Rectangle-19-Copy-9",
	              fill: "#B6BFF3"
	            }),
	            _react2.default.createElement("path", {
	              d: "M28.3359163,5.40165426 C18.0481585,8.30196926 9.97377203,16.2871981 6.95941088,26.5421196 L6.88634688,26.7906849 C3.72535777,37.5444378 3.75030667,48.9840505 6.95817167,59.7239135 C9.97371351,69.8198827 17.9448625,77.6712357 28.0853344,80.5335626 L31.1995497,81.4126047 C44.0549737,85.0412747 57.6621612,85.0540605 70.5243818,81.4495558 L73.8268684,80.524068 C84.016726,77.6684655 92.0272568,69.7818985 95.0414212,59.6378127 C98.2495601,48.840911 98.2583999,37.3454265 95.0668699,26.5436036 L95.0409843,26.4559931 C92.0269945,16.2550602 83.9814922,8.3193363 73.7401165,5.44576902 L70.5943981,4.56313042 C57.7183933,0.950328074 44.0954033,0.958754527 31.2238777,4.58748292 L28.3359163,5.40165426 Z",
	              id: "Rectangle-19-Copy-10",
	              stroke: "#222232",
	              strokeWidth: "2"
	            }),
	            _react2.default.createElement(
	              "g",
	              {
	                id: "slack",
	                transform: "translate(25.000000, 19.000000)",
	                fillRule: "nonzero" },
	              _react2.default.createElement("path", {
	                d: "M17.4126232,24.6244729 L20.5824922,33.405262 L30.0382807,30.2952024 L26.8684116,21.5144133 L17.4126232,24.6244729 Z M14.9833728,17.8952564 L24.4391612,14.7851967 L22.265216,8.76319578 C21.5946306,6.90562108 22.5855351,4.86519279 24.4784631,4.20577164 C26.3713911,3.54635049 28.4495293,4.51764584 29.1201146,6.37522054 L31.337094,12.5164295 L36.8299735,10.709792 C38.7341217,10.0835074 40.7949919,11.0909233 41.433056,12.9599184 C42.0711201,14.8289135 41.0447561,16.8517374 39.1406079,17.478022 L33.7663444,19.2456461 L36.9362135,28.0264352 L42.2075103,26.2926774 C44.1116584,25.6663928 46.1725287,26.6738087 46.8105927,28.5428038 C47.4486568,30.411799 46.4222928,32.4346228 44.5181447,33.0609074 L39.3654639,34.7556518 L41.2165183,39.8832195 C41.8871036,41.7407942 40.8961991,43.7812225 39.0032711,44.4406436 C37.1103431,45.1000648 35.032205,44.1287694 34.3616196,42.2711947 L32.4675311,37.024419 L23.0117426,40.1344786 L24.8536846,45.2368042 C25.52427,47.0943789 24.5333655,49.1348072 22.6404375,49.7942284 C20.7475095,50.4536495 18.6693713,49.4823542 17.998786,47.6247795 L16.1138098,42.4032458 L10.1700265,44.3581881 C8.2658783,44.9844726 6.20500808,43.9770567 5.56694401,42.1080616 C4.92887993,40.2390665 5.9552439,38.2162426 7.85939208,37.5899581 L13.6845594,35.6740292 L10.5146903,26.8932401 L4.79248973,28.7753026 C2.88834155,29.4015872 0.827471333,28.3941713 0.189407261,26.5251762 C-0.44865681,24.6561811 0.577707151,22.6333572 2.48185533,22.0070726 L8.08543994,20.1640235 L5.90238232,14.1167805 C5.23179697,12.2592058 6.22270147,10.2187775 8.11562947,9.55935639 C10.0085575,8.89993524 12.0866956,9.8712306 12.757281,11.7288053 L14.9833728,17.8952564 Z",
	                id: "Combined-Shape",
	                fill: "#9192C5"
	              }),
	              _react2.default.createElement("path", {
	                d: "M20.4126232,21.6244729 L23.5824922,30.405262 L33.0382807,27.2952024 L29.8684116,18.5144133 L20.4126232,21.6244729 Z M17.9833728,14.8952564 L27.4391612,11.7851967 L25.265216,5.76319578 C24.5946306,3.90562108 25.5855351,1.86519279 27.4784631,1.20577164 C29.3713911,0.546350487 31.4495293,1.51764584 32.1201146,3.37522054 L34.337094,9.51642955 L39.8299735,7.70979196 C41.7341217,7.08350739 43.7949919,8.09092332 44.433056,9.95991843 C45.0711201,11.8289135 44.0447561,13.8517374 42.1406079,14.478022 L36.7663444,16.2456461 L39.9362135,25.0264352 L45.2075103,23.2926774 C47.1116584,22.6663928 49.1725287,23.6738087 49.8105927,25.5428038 C50.4486568,27.411799 49.4222928,29.4346228 47.5181447,30.0609074 L42.3654639,31.7556518 L44.2165183,36.8832195 C44.8871036,38.7407942 43.8961991,40.7812225 42.0032711,41.4406436 C40.1103431,42.1000648 38.032205,41.1287694 37.3616196,39.2711947 L35.4675311,34.024419 L26.0117426,37.1344786 L27.8536846,42.2368042 C28.52427,44.0943789 27.5333655,46.1348072 25.6404375,46.7942284 C23.7475095,47.4536495 21.6693713,46.4823542 20.998786,44.6247795 L19.1138098,39.4032458 L13.1700265,41.3581881 C11.2658783,41.9844726 9.20500808,40.9770567 8.56694401,39.1080616 C7.92887993,37.2390665 8.9552439,35.2162426 10.8593921,34.5899581 L16.6845594,32.6740292 L13.5146903,23.8932401 L7.79248973,25.7753026 C5.88834155,26.4015872 3.82747133,25.3941713 3.18940726,23.5251762 C2.55134319,21.6561811 3.57770715,19.6333572 5.48185533,19.0070726 L11.0854399,17.1640235 L8.90238232,11.1167805 C8.23179697,9.25920583 9.22270147,7.21877755 11.1156295,6.55935639 C13.0085575,5.89993524 15.0866956,6.8712306 15.757281,8.72880529 L17.9833728,14.8952564 Z",
	                id: "Combined-Shape",
	                fill: "#2C2C46"
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	var unlimited = exports.unlimited = function unlimited(_ref8) {
	  var style = _ref8.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      width: "99px",
	      height: "87px",
	      viewBox: "0 0 99 87",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { id: "icon-system", transform: "translate(-714.000000, -511.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Group-49", transform: "translate(714.000000, 511.000000)" },
	          _react2.default.createElement(
	            "g",
	            { id: "Group-31-Copy-2" },
	            _react2.default.createElement("path", {
	              d: "M25.0645741,5.43917134 L27.9525354,4.625 L27.9525354,4.625 C41.0010932,0.946362859 54.8114509,0.93782051 67.8645495,4.60031256 L71.0102679,5.48295116 L71.0102679,5.48295116 C81.582847,8.44944884 89.8885386,16.6418119 93,27.1726402 L93.0258856,27.2602507 L93.0258856,27.2602507 C96.2722096,38.2475255 96.2632181,49.9403711 93,60.9226402 L93,60.9226402 L93,60.9226402 C89.8879801,71.3960558 81.6173858,79.5386618 71.0967123,82.4869721 L67.7942257,83.4124599 L67.7942257,83.4124599 C54.7548943,87.0665981 40.9603379,87.0536362 27.9278967,83.375 L24.8136814,82.4959579 L24.8136814,82.4959579 C14.3436989,79.5406208 6.11353066,71.4341412 3,61.0101076 L3,61.0101076 L3,61.0101076 C-0.263211178,50.0849468 -0.288590526,38.4479633 2.926936,27.5086729 L3,27.2601076 L3,27.2601076 C6.11138763,16.6750999 14.4456731,8.4328419 25.0645741,5.43917134 Z",
	              id: "Rectangle-19-Copy-9",
	              fill: "#B6BFF3"
	            }),
	            _react2.default.createElement("path", {
	              d: "M28.3359163,5.40165426 C18.0481585,8.30196926 9.97377203,16.2871981 6.95941088,26.5421196 L6.88634688,26.7906849 C3.72535777,37.5444378 3.75030667,48.9840505 6.95817167,59.7239135 C9.97371351,69.8198827 17.9448625,77.6712357 28.0853344,80.5335626 L31.1995497,81.4126047 C44.0549737,85.0412747 57.6621612,85.0540605 70.5243818,81.4495558 L73.8268684,80.524068 C84.016726,77.6684655 92.0272568,69.7818985 95.0414212,59.6378127 C98.2495601,48.840911 98.2583999,37.3454265 95.0668699,26.5436036 L95.0409843,26.4559931 C92.0269945,16.2550602 83.9814922,8.3193363 73.7401165,5.44576902 L70.5943981,4.56313042 C57.7183933,0.950328074 44.0954033,0.958754527 31.2238777,4.58748292 L28.3359163,5.40165426 Z",
	              id: "Rectangle-19-Copy-10",
	              stroke: "#222232",
	              strokeWidth: "2"
	            })
	          ),
	          _react2.default.createElement(
	            "g",
	            { id: "Group-41", transform: "translate(24.000000, 26.000000)" },
	            _react2.default.createElement("path", {
	              d: "M6.5775,30.735 C4.54082315,29.3483264 3.02417165,27.5608443 2.0275,25.3725 C1.03082835,23.1841557 0.5325,20.8550123 0.5325,18.385 C0.5325,15.9149876 1.03082835,13.5858443 2.0275,11.3975 C3.02417165,9.20915572 4.54082315,7.4216736 6.5775,6.035 C8.61417685,4.6483264 11.1058186,3.955 14.0525,3.955 C16.652513,3.955 18.8949906,4.63749317 20.78,6.0025 C22.6650094,7.36750682 24.5824902,9.3066541 26.5325,11.82 C28.4391762,9.34998765 30.3349906,7.4216736 32.22,6.035 C34.1050094,4.6483264 36.3258206,3.955 38.8825,3.955 C41.8725149,3.955 44.3858231,4.6483264 46.4225,6.035 C48.4591768,7.4216736 49.9758284,9.20915572 50.9725,11.3975 C51.9691717,13.5858443 52.4675,15.9149876 52.4675,18.385 C52.4675,20.8550123 51.9691717,23.1841557 50.9725,25.3725 C49.9758284,27.5608443 48.4591768,29.3483264 46.4225,30.735 C44.3858231,32.1216736 41.8941814,32.815 38.9475,32.815 C36.347487,32.815 34.0941762,32.14334 32.1875,30.8 C30.2808238,29.4566599 28.3741762,27.5716788 26.4675,25.145 C24.6041574,27.5716788 22.7191762,29.4566599 20.8125,30.8 C18.9058238,32.14334 16.652513,32.815 14.0525,32.815 C11.1058186,32.815 8.61417685,32.1216736 6.5775,30.735 Z M18.5375,22.675 C19.88084,21.2883264 20.8991632,19.9016736 21.5925,18.515 C20.8124961,17.0416593 19.7616733,15.5900071 18.44,14.16 C17.1183267,12.7299928 15.7208407,12.015 14.2475,12.015 C12.7741593,12.015 11.506672,12.5891609 10.445,13.7375 C9.38332802,14.8858391 8.8525,16.4349902 8.8525,18.385 C8.8525,20.3350097 9.38332802,21.8841609 10.445,23.0325 C11.506672,24.1808391 12.7741593,24.755 14.2475,24.755 C15.7641742,24.755 17.1941599,24.0616736 18.5375,22.675 Z M42.49,23.0325 C43.551672,21.8841609 44.0825,20.3350097 44.0825,18.385 C44.0825,16.4349902 43.551672,14.8858391 42.49,13.7375 C41.428328,12.5891609 40.1825071,12.015 38.7525,12.015 C37.2358258,12.015 35.7950068,12.7408261 34.43,14.1925 C33.0649932,15.6441739 32.0358368,17.0849928 31.3425,18.515 C32.0791704,19.9016736 33.11916,21.2883264 34.4625,22.675 C35.8058401,24.0616736 37.2358258,24.755 38.7525,24.755 C40.1825071,24.755 41.428328,24.1808391 42.49,23.0325 Z",
	              id: "\u221E",
	              fill: "#9192C5"
	            }),
	            _react2.default.createElement("path", {
	              d: "M8.5775,27.735 C6.54082315,26.3483264 5.02417165,24.5608443 4.0275,22.3725 C3.03082835,20.1841557 2.5325,17.8550123 2.5325,15.385 C2.5325,12.9149876 3.03082835,10.5858443 4.0275,8.3975 C5.02417165,6.20915572 6.54082315,4.4216736 8.5775,3.035 C10.6141769,1.6483264 13.1058186,0.955 16.0525,0.955 C18.652513,0.955 20.8949906,1.63749317 22.78,3.0025 C24.6650094,4.36750682 26.5824902,6.3066541 28.5325,8.82 C30.4391762,6.34998765 32.3349906,4.4216736 34.22,3.035 C36.1050094,1.6483264 38.3258206,0.955 40.8825,0.955 C43.8725149,0.955 46.3858231,1.6483264 48.4225,3.035 C50.4591768,4.4216736 51.9758284,6.20915572 52.9725,8.3975 C53.9691717,10.5858443 54.4675,12.9149876 54.4675,15.385 C54.4675,17.8550123 53.9691717,20.1841557 52.9725,22.3725 C51.9758284,24.5608443 50.4591768,26.3483264 48.4225,27.735 C46.3858231,29.1216736 43.8941814,29.815 40.9475,29.815 C38.347487,29.815 36.0941762,29.14334 34.1875,27.8 C32.2808238,26.4566599 30.3741762,24.5716788 28.4675,22.145 C26.6041574,24.5716788 24.7191762,26.4566599 22.8125,27.8 C20.9058238,29.14334 18.652513,29.815 16.0525,29.815 C13.1058186,29.815 10.6141769,29.1216736 8.5775,27.735 Z M20.5375,19.675 C21.88084,18.2883264 22.8991632,16.9016736 23.5925,15.515 C22.8124961,14.0416593 21.7616733,12.5900071 20.44,11.16 C19.1183267,9.72999285 17.7208407,9.015 16.2475,9.015 C14.7741593,9.015 13.506672,9.58916092 12.445,10.7375 C11.383328,11.8858391 10.8525,13.4349902 10.8525,15.385 C10.8525,17.3350097 11.383328,18.8841609 12.445,20.0325 C13.506672,21.1808391 14.7741593,21.755 16.2475,21.755 C17.7641742,21.755 19.1941599,21.0616736 20.5375,19.675 Z M44.49,20.0325 C45.551672,18.8841609 46.0825,17.3350097 46.0825,15.385 C46.0825,13.4349902 45.551672,11.8858391 44.49,10.7375 C43.428328,9.58916092 42.1825071,9.015 40.7525,9.015 C39.2358258,9.015 37.7950068,9.74082607 36.43,11.1925 C35.0649932,12.6441739 34.0358368,14.0849928 33.3425,15.515 C34.0791704,16.9016736 35.11916,18.2883264 36.4625,19.675 C37.8058401,21.0616736 39.2358258,21.755 40.7525,21.755 C42.1825071,21.755 43.428328,21.1808391 44.49,20.0325 Z",
	              id: "\u221E",
	              fill: "#F7F7F9"
	            }),
	            _react2.default.createElement("path", {
	              d: "M8.5775,27.735 C6.54082315,26.3483264 5.02417165,24.5608443 4.0275,22.3725 C3.03082835,20.1841557 2.5325,17.8550123 2.5325,15.385 C2.5325,12.9149876 3.03082835,10.5858443 4.0275,8.3975 C5.02417165,6.20915572 6.54082315,4.4216736 8.5775,3.035 C10.6141769,1.6483264 13.1058186,0.955 16.0525,0.955 C18.652513,0.955 20.8949906,1.63749317 22.78,3.0025 C24.6650094,4.36750682 26.5824902,6.3066541 28.5325,8.82 C30.4391762,6.34998765 32.3349906,4.4216736 34.22,3.035 C36.1050094,1.6483264 38.3258206,0.955 40.8825,0.955 C43.8725149,0.955 46.3858231,1.6483264 48.4225,3.035 C50.4591768,4.4216736 51.9758284,6.20915572 52.9725,8.3975 C53.9691717,10.5858443 54.4675,12.9149876 54.4675,15.385 C54.4675,17.8550123 53.9691717,20.1841557 52.9725,22.3725 C51.9758284,24.5608443 50.4591768,26.3483264 48.4225,27.735 C46.3858231,29.1216736 43.8941814,29.815 40.9475,29.815 C38.347487,29.815 36.0941762,29.14334 34.1875,27.8 C32.2808238,26.4566599 30.3741762,24.5716788 28.4675,22.145 C26.6041574,24.5716788 24.7191762,26.4566599 22.8125,27.8 C20.9058238,29.14334 18.652513,29.815 16.0525,29.815 C13.1058186,29.815 10.6141769,29.1216736 8.5775,27.735 Z M20.5375,19.675 C21.88084,18.2883264 22.8991632,16.9016736 23.5925,15.515 C22.8124961,14.0416593 21.7616733,12.5900071 20.44,11.16 C19.1183267,9.72999285 17.7208407,9.015 16.2475,9.015 C14.7741593,9.015 13.506672,9.58916092 12.445,10.7375 C11.383328,11.8858391 10.8525,13.4349902 10.8525,15.385 C10.8525,17.3350097 11.383328,18.8841609 12.445,20.0325 C13.506672,21.1808391 14.7741593,21.755 16.2475,21.755 C17.7641742,21.755 19.1941599,21.0616736 20.5375,19.675 Z M44.49,20.0325 C45.551672,18.8841609 46.0825,17.3350097 46.0825,15.385 C46.0825,13.4349902 45.551672,11.8858391 44.49,10.7375 C43.428328,9.58916092 42.1825071,9.015 40.7525,9.015 C39.2358258,9.015 37.7950068,9.74082607 36.43,11.1925 C35.0649932,12.6441739 34.0358368,14.0849928 33.3425,15.515 C34.0791704,16.9016736 35.11916,18.2883264 36.4625,19.675 C37.8058401,21.0616736 39.2358258,21.755 40.7525,21.755 C42.1825071,21.755 43.428328,21.1808391 44.49,20.0325 Z",
	              id: "\u221E",
	              stroke: "#222232",
	              strokeWidth: "2"
	            })
	          )
	        )
	      )
	    )
	  );
	};
	
	var Sample2 = exports.Sample2 = function Sample2(_ref9) {
	  var style = _ref9.style;
	  return _react2.default.createElement("svg", { style: style });
	};
	
	var Sample3 = exports.Sample3 = function Sample3(_ref10) {
	  var style = _ref10.style;
	  return _react2.default.createElement("svg", { style: style });
	};

/***/ }),

/***/ 496:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/SectionFiveBackground.750ce128.png";

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/SectionFourBackground.bbb6f599.png";

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/SectionOneBackground.904c4b95.png";

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/SectionThreeBackground.03206d0e.png";

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/SectionTwoBackground.facae413.png";

/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/HeaderConversation.fb81b157.svg";

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/customerChat.9a082a2a.svg";

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/slackMeetSmallchat.eac0477a.svg";

/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _FeatureIcon = __webpack_require__(44);
	
	var _FeatureIcon2 = _interopRequireDefault(_FeatureIcon);
	
	var _colors = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ArticleCardsContainer = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: "ArticleCard__ArticleCardsContainer"
	})(["display:flex;justify-content:center;position:relative;width:100%;margin-top:50px;max-width:1200px;@media (max-width:768px){flex-direction:column;align-items:center;width:90%;margin-top:150px;margin-bottom:50px;}@media screen and (max-width:480px){width:100%;margin-top:20px;margin-bottom:50px;}"]);
	
	var ArticleCardWrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: "ArticleCard__ArticleCardWrapper"
	})(["display:flex;align-items:center;overflow:hidden;justify-content:center;flex-direction:row;width:100%;max-width:500px;margin-right:20px;margin-left:0px;background-color:white;box-shadow:0px 5px 10px ", ";border-radius:12px;transition:300ms ease all;color:", ";&:nth-child(2){margin-right:0px;margin-left:20px;@media (max-width:768px){margin-right:0px;margin-left:0px;margin-bottom:0px;padding:5px;}@media (max-width:480px){width:100%;padding:5px;}}:hover{transform:translateY(-3px);box-shadow:0px 8px 20px ", ";}a{color:", ";display:block;height:90%;width:90%;}@media (max-width:768px){margin-right:0px;margin-left:0px;margin-bottom:30px;padding:5px;}@media (max-width:480px){margin-bottom:20px;width:100%;padding:5px;}"], _colors.SECONDARY_TEXT, _colors.PRIMARY_TEXT, _colors.SECONDARY_TEXT, _colors.ACTIVE_TEXT);
	
	var ArticleCardItemContent = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: "ArticleCard__ArticleCardItemContent"
	})(["display:flex;flex-direction:column;text-align:left;padding:15px 0px;padding-right:5px;margin-left:30px;width:100%;@media (max-width:768px){margin-left:35px;padding:10px 0px;}@media (max-width:615px){padding:5px 0px;}"]);
	
	var ArticleCardItemIcon = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: "ArticleCard__ArticleCardItemIcon"
	})(["transform:scale(1.7);width:30%;max-width:100px;position:relative;right:15px;flex-shrink:0;@media (max-width:768px){transform:scale(1.4);top:2px;width:20%;}@media (max-width:480px){transform:scale(0.8);right:30px;width:10%;}"]);
	
	var ArticleCardItemName = /*#__PURE__*/_styledComponents2.default.h4.withConfig({
	  displayName: "ArticleCard__ArticleCardItemName"
	})(["font-size:16px;@media (max-width:615px){font-size:14px;}"]);
	
	var ArticleCardItemDescription = /*#__PURE__*/_styledComponents2.default.p.withConfig({
	  displayName: "ArticleCard__ArticleCardItemDescription"
	})(["font-size:15px;line-height:21px;@media (max-width:768px){font-size:14px;line-height:19px;}@media (max-width:615px){font-size:13px;line-height:17px;}"]);
	
	var ArticleCardItemLink = /*#__PURE__*/_styledComponents2.default.a.withConfig({
	  displayName: "ArticleCard__ArticleCardItemLink"
	})(["font-size:15px;margin-right:20px;margin-left:0px;&:nth-child(2){margin-right:0px;margin-left:20px;@media (max-width:768px){margin-right:0px;margin-left:0px;margin-bottom:0px;padding:5px;}@media (max-width:480px){width:100%;padding:5px;}}@media (max-width:768px){margin-right:0px;margin-left:0px;margin-bottom:30px;padding:5px;}@media (max-width:615px){font-size:13px;margin-bottom:20px;width:100%;padding:5px;}"]);
	
	var ArticleCard = function ArticleCard(_ref) {
	  var articles = _ref.articles;
	
	  if (!articles || articles.length < 1) {
	    return null;
	  }
	  return _react2.default.createElement(
	    ArticleCardsContainer,
	    null,
	    articles.slice(0, 4).map(function (article, index, props) {
	      return _react2.default.createElement(
	        ArticleCardItemLink,
	        { href: article.articleLink },
	        _react2.default.createElement(
	          ArticleCardWrapper,
	          { key: index },
	          _react2.default.createElement(
	            ArticleCardItemIcon,
	            null,
	            _react2.default.createElement(_FeatureIcon2.default, { name: article.iconName })
	          ),
	          _react2.default.createElement(
	            ArticleCardItemContent,
	            null,
	            _react2.default.createElement(
	              ArticleCardItemName,
	              null,
	              article.articleName
	            ),
	            _react2.default.createElement(
	              ArticleCardItemDescription,
	              null,
	              article.articleDescription
	            ),
	            _react2.default.createElement(
	              "p",
	              {
	                style: {
	                  color: "#5759FF",
	                  fontSize: "15px",
	                  fontWeight: "700"
	                } },
	              article.articleLinkText
	            )
	          )
	        )
	      );
	    })
	  );
	};
	
	exports.default = function (_ref2) {
	  var articles = _ref2.articles;
	  return _react2.default.createElement(ArticleCard, { articles: articles });
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _FeatureIcons = __webpack_require__(83);
	
	var FeatureIcons = _interopRequireWildcard(_FeatureIcons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FeatureIcon = function FeatureIcon(_ref) {
	  var name = _ref.name,
	      style = _ref.style,
	      size = _ref.size;
	
	  var FeatureIcon = FeatureIcons[name];
	  if (FeatureIcon) {
	    var _style = { width: size, height: size };
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(FeatureIcon, { name: name })
	    );
	  } else {
	    return null;
	  }
	};
	
	FeatureIcon.displayName = 'FeatureIcon';
	
	exports.default = FeatureIcon;
	module.exports = exports['default'];

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeaderConvoWrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: "HeaderConvo__HeaderConvoWrapper"
	})(["display:flex;@media (max-width:980px){position:relative;transform:scale(0.8);right:5%;}@media (max-width:786px){position:relative;transform:scale(0.8);right:0%;margin-bottom:100px;}@media (max-width:420px){position:relative;transform:scale(0.6);right:0%;margin-bottom:0px;}"]);
	
	var HeaderConvo = function HeaderConvo(props) {
	  return _react2.default.createElement(
	    HeaderConvoWrapper,
	    null,
	    _react2.default.createElement("img", { src: props.name })
	  );
	};
	
	exports.default = function (_ref) {
	  var name = _ref.name;
	  return _react2.default.createElement(HeaderConvo, { name: name });
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _HomeFeatureSetList = __webpack_require__(227);
	
	var _HomeFeatureSetList2 = _interopRequireDefault(_HomeFeatureSetList);
	
	var _colors = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeFeatureSetWrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: "HomeFeatureSet__HomeFeatureSetWrapper"
	})(["position:relative;display:flex;align-items:center;justify-content:center;flex-direction:column;width:80%;max-width:1200px;padding:20px 40px 40px 40px;background-color:white;box-shadow:0px 20px 30px ", ";border-radius:12px;margin-bottom:100px;@media (max-width:768px){margin-bottom:50px;width:90%;padding:20px;}@media (max-width:480px){text-align:center;width:100%;flex-direction:column;align-items:center;justify-content:center;padding:20px 10px 30px 10px;margin-bottom:10px;}"], _colors.SMALLCHAT_SHADOW);
	var HomeFeatureSetTitle = /*#__PURE__*/_styledComponents2.default.h3.withConfig({
	  displayName: "HomeFeatureSet__HomeFeatureSetTitle"
	})(["margin-bottom:30px;margin-top:15px;@media (max-width:768px){margin-bottom:10px;margin-top:5px;}"]);
	
	var HomeFeatureSet = function HomeFeatureSet(props) {
	  return _react2.default.createElement(
	    HomeFeatureSetWrapper,
	    null,
	    _react2.default.createElement(
	      HomeFeatureSetTitle,
	      null,
	      props.title
	    ),
	    _react2.default.createElement(_HomeFeatureSetList2.default, { features: props.features })
	  );
	};
	
	exports.default = HomeFeatureSet;
	module.exports = exports["default"];

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _FeatureIcon = __webpack_require__(44);
	
	var _FeatureIcon2 = _interopRequireDefault(_FeatureIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeFeatureSetListWrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: "HomeFeatureSetList__HomeFeatureSetListWrapper"
	})(["display:flex;flex-direction:row;flex-wrap:wrap;width:100%;max-width:1200px;align-items:center;justify-content:space-between;margin:0 auto;@media (max-width:768px){align-items:flex-start;justify-content:flex-start;}@media (max-width:615px){justify-content:center;width:100%;}"]);
	
	var HomeFeatureSetItemWrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: "HomeFeatureSetList__HomeFeatureSetItemWrapper"
	})(["display:flex;flex-direction:row;align-items:center;justify-content:flex-start;margin:10px 5px;width:47%;@media (max-width:980px){align-items:center;justify-content:center;}@media (max-width:768px){width:42%;margin:10px 12px;flex-direction:column;}@media (max-width:480px){flex-direction:column;width:45%;margin:5px;}"]);
	
	var HomeFeatureSetItemIcon = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: "HomeFeatureSetList__HomeFeatureSetItemIcon"
	})(["display:flex;align-self:center;position:relative;@media (max-width:980px){transform:scale(0.6);width:30%;}@media (max-width:768px){left:-5%;width:10%;}@media (max-width:480px){left:-10%;transform:scale(0.5);}"]);
	var HomeFeatureSetItemContent = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: "HomeFeatureSetList__HomeFeatureSetItemContent"
	})(["display:flex;flex-direction:column;align-items:flex-start;justify-content:center;margin-left:30px;width:100%;@media (max-width:980px){margin-left:10px;}@media (max-width:768px){margin-left:0px;font-size:13px;line-height:19px;}@media (max-width:480px){text-align:center;font-size:12px;line-height:15px;margin:0px;margin-top:-10px;}"]);
	
	var HomeFeatureSetItemName = /*#__PURE__*/_styledComponents2.default.h5.withConfig({
	  displayName: "HomeFeatureSetList__HomeFeatureSetItemName"
	})(["line-height:21px;max-width:100%;@media (max-width:980px){line-height:20px;}@media (max-width:768px){text-align:center;margin:0 auto;line-height:19px;}@media (max-width:480px){line-height:16px;}"]);
	
	var HomeFeatureSetItemDescription = /*#__PURE__*/_styledComponents2.default.p.withConfig({
	  displayName: "HomeFeatureSetList__HomeFeatureSetItemDescription"
	})(["font-size:15px;line-height:21px;max-width:100%;@media (max-width:980px){font-size:14px;line-height:20px;}@media (max-width:768px){text-align:center;margin:0 auto;font-size:13px;line-height:19px;}@media (max-width:480px){font-size:12px;line-height:16px;}"]);
	
	var HomeFeatureSetItemLink = /*#__PURE__*/_styledComponents2.default.a.withConfig({
	  displayName: "HomeFeatureSetList__HomeFeatureSetItemLink"
	})(["font-size:15px;@media (max-width:980px){font-size:14px;line-height:20px;}@media (max-width:768px){text-align:center;margin:0 auto;font-size:13px;line-height:19px;}@media (max-width:480px){margin:0 auto;margin-top:5px;font-size:12px;line-height:15px;}"]);
	
	var HomeFeatureSetList = function HomeFeatureSetList(_ref) {
	  var features = _ref.features;
	
	  if (!features || features.length < 1) {
	    return null;
	  }
	  return _react2.default.createElement(
	    HomeFeatureSetListWrapper,
	    null,
	    features.map(function (feature, index, props) {
	      return _react2.default.createElement(
	        HomeFeatureSetItemWrapper,
	        { key: index },
	        _react2.default.createElement(
	          HomeFeatureSetItemIcon,
	          null,
	          _react2.default.createElement(_FeatureIcon2.default, { name: feature.iconName })
	        ),
	        _react2.default.createElement(
	          HomeFeatureSetItemContent,
	          null,
	          _react2.default.createElement(
	            HomeFeatureSetItemName,
	            null,
	            feature.featureName
	          ),
	          _react2.default.createElement(
	            HomeFeatureSetItemDescription,
	            null,
	            feature.featureDescription
	          ),
	          _react2.default.createElement(
	            HomeFeatureSetItemLink,
	            { href: feature.featureLink },
	            feature.featureLinkText
	          )
	        )
	      );
	    })
	  );
	};
	
	exports.default = function (_ref2) {
	  var features = _ref2.features;
	  return _react2.default.createElement(HomeFeatureSetList, { features: features });
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScreensizeProvider = function (_Component) {
	  _inherits(ScreensizeProvider, _Component);
	
	  function ScreensizeProvider() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ScreensizeProvider);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      screensize: _this.getScreensize()
	    }, _this.handleResize = function (e) {
	      var nextScreensize = _this.getScreensize();
	      if (nextScreensize !== _this.state.screensize) {
	        _this.setState({ screensize: nextScreensize });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ScreensizeProvider.prototype.getChildContext = function getChildContext() {
	    return {
	      screensize: this.state.screensize
	    };
	  };
	
	  ScreensizeProvider.prototype.componentDidMount = function componentDidMount() {
	    this.setState({ screensize: this.getScreensize() });
	    window.addEventListener("resize", this.handleResize);
	  };
	
	  ScreensizeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("resize", this.handleResize);
	  };
	
	  ScreensizeProvider.prototype.getScreensize = function getScreensize() {
	    if (typeof window !== "undefined") {
	      if (window.innerWidth <= 480) return "phone";
	      if (window.innerWidth <= 615) return "l-phone";
	      if (window.innerWidth <= 768) return "tablet";
	      if (window.innerWidth <= 980) return "small";
	    }
	    return "desktop";
	  };
	
	  ScreensizeProvider.prototype.render = function render() {
	    return _react2.default.Children.only(this.props.children);
	  };
	
	  return ScreensizeProvider;
	}(_react.Component);
	
	ScreensizeProvider.displayName = "ScreensizeProvider";
	ScreensizeProvider.childContextTypes = {
	  screensize: _propTypes2.default.string.isRequired
	};
	exports.default = ScreensizeProvider;
	module.exports = exports["default"];

/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionBlockContentWrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: "SectionBlockContent__SectionBlockContentWrapper"
	})(["position:relative;display:flex;flex-direction:column;z-index:3;width:", ";margin:0 50px;margin-top:50px;@media (max-width:900px){margin-right:0px;}@media (max-width:768px){text-align:center;margin-top:-50px;margin:0px;width:70%;}@media (max-width:480px){text-align:center;margin:0px;width:95%;}"], function (props) {
	  return props.bigIllustration ? "30%" : "50%";
	});
	var SectionBlockHeadline = /*#__PURE__*/_styledComponents2.default.h2.withConfig({
	  displayName: "SectionBlockContent__SectionBlockHeadline"
	})(["margin-bottom:20px;@media (max-width:480px){margin-bottom:15px;}"]);
	
	var SectionBlockCopy = /*#__PURE__*/_styledComponents2.default.p.withConfig({
	  displayName: "SectionBlockContent__SectionBlockCopy"
	})(["margin-bottom:20px;@media (max-width:768px){margin-bottom:10px;}@media (max-width:480px){margin-bottom:15px;}"]);
	
	var SectionBlockProTip = /*#__PURE__*/_styledComponents2.default.p.withConfig({
	  displayName: "SectionBlockContent__SectionBlockProTip"
	})(["color:", ";margin-bottom:40px;@media (max-width:768px){margin-bottom:10px;}"], _colors.SECONDARY_TEXT);
	
	var SectionBlockCTA = /*#__PURE__*/_styledComponents2.default.a.withConfig({
	  displayName: "SectionBlockContent__SectionBlockCTA"
	})(["color:", ";margin-bottom:40px;@media (max-width:768px){margin-bottom:10px;}"], _colors.ACTIVE_TEXT);
	
	var SectionBlockContent = function SectionBlockContent(props) {
	  return _react2.default.createElement(
	    SectionBlockContentWrapper,
	    { bigIllustration: props.bigIllustration },
	    _react2.default.createElement(
	      SectionBlockHeadline,
	      null,
	      props.headline
	    ),
	    _react2.default.createElement(
	      SectionBlockCopy,
	      null,
	      props.copy
	    ),
	    _react2.default.createElement(
	      SectionBlockProTip,
	      null,
	      props.protips
	    ),
	    _react2.default.createElement(
	      SectionBlockCTA,
	      { href: props.link },
	      props.linkText
	    )
	  );
	};
	
	exports.default = function (_ref) {
	  var bigIllustration = _ref.bigIllustration,
	      headline = _ref.headline,
	      copy = _ref.copy,
	      protips = _ref.protips,
	      link = _ref.link,
	      linkText = _ref.linkText;
	  return _react2.default.createElement(SectionBlockContent, {
	    bigIllustration: bigIllustration,
	    headline: headline,
	    copy: copy,
	    protips: protips,
	    link: link,
	    linkText: linkText
	  });
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionCenteredContentWrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: "SectionCenteredContent__SectionCenteredContentWrapper"
	})(["display:flex;flex-direction:column;align-items:center;justify-content:center;position:relative;z-index:2;width:95%;max-width:1200px;margin:0px 50px;@media (max-width:900px){margin:0px;}@media (max-width:768px){text-align:center;margin:0px;margin-top:100px;width:70%;}@media (max-width:420px){width:100%;top:50px;}"]);
	var SectionCenteredHeadline = /*#__PURE__*/_styledComponents2.default.h2.withConfig({
	  displayName: "SectionCenteredContent__SectionCenteredHeadline"
	})(["width:90%;margin-bottom:20px;text-align:center;"]);
	
	var SectionCenteredCopy = /*#__PURE__*/_styledComponents2.default.p.withConfig({
	  displayName: "SectionCenteredContent__SectionCenteredCopy"
	})(["width:70%;margin-bottom:150px;text-align:center;font-size:20px;@media (max-width:768px){width:50%;font-size:15px;margin-bottom:20px;}@media (max-width:615px){width:60%;margin-bottom:0px;}"]);
	
	var SectionCenteredContent = function SectionCenteredContent(props) {
	  return _react2.default.createElement(
	    SectionCenteredContentWrapper,
	    null,
	    _react2.default.createElement(
	      SectionCenteredHeadline,
	      null,
	      props.headline
	    ),
	    _react2.default.createElement(
	      SectionCenteredCopy,
	      null,
	      props.copy
	    ),
	    props.children
	  );
	};
	
	exports.default = function (_ref) {
	  var children = _ref.children,
	      headline = _ref.headline,
	      copy = _ref.copy;
	  return _react2.default.createElement(
	    SectionCenteredContent,
	    { headline: headline, copy: copy },
	    children
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionContainer = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: "SectionContainer"
	})(["position:relative;z-index:", ";margin:0 auto;padding:0 1.5rem;display:flex;flex-direction:", ";align-items:center;justify-content:center;min-height:", ";width:100%;max-width:1600px;margin-bottom:50px;@media (max-width:980px){align-items:center;justify-content:center;}@media (max-width:768px){flex-direction:column-reverse;align-items:center;justify-content:center;padding:0 1rem;}@media screen and (max-width:615px){padding:0 0.8rem;margin-bottom:20px;}"], function (props) {
	  return props.zIndex;
	}, function (props) {
	  return props.reversed ? "row-reverse" : "row";
	}, function (props) {
	  return props.height;
	});
	
	exports.default = function (_ref) {
	  var children = _ref.children,
	      reversed = _ref.reversed,
	      height = _ref.height,
	      zIndex = _ref.zIndex;
	  return _react2.default.createElement(
	    SectionContainer,
	    { zIndex: zIndex, reversed: reversed, height: height },
	    children
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _AddtoSlack = __webpack_require__(31);
	
	var _AddtoSlack2 = _interopRequireDefault(_AddtoSlack);
	
	var _HeaderConvo = __webpack_require__(225);
	
	var _HeaderConvo2 = _interopRequireDefault(_HeaderConvo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionHeaderWrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: "SectionHeaderContent__SectionHeaderWrapper"
	})(["position:relative;display:flex;flex-direction:row;align-items:center;justify-content:center;margin:0 auto;width:100%;max-width:1600px;@media (max-width:980px){}@media (max-width:768px){text-align:center;flex-direction:column;align-items:center;justify-content:center;}@media screen and (max-width:480px){margin-top:-100px;}"]);
	
	var SectionHeaderContentWrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: "SectionHeaderContent__SectionHeaderContentWrapper"
	})(["display:flex;position:relative;flex-direction:column;width:55%;padding-left:50px;max-width:650px;@media (max-width:980px){width:70%;}@media (max-width:768px){margin-top:-100px;padding-left:0px;align-items:center;justify-content:center;}@media (max-width:480px){width:90%;}"]);
	var SectionHeaderHeadline = /*#__PURE__*/_styledComponents2.default.h1.withConfig({
	  displayName: "SectionHeaderContent__SectionHeaderHeadline"
	})(["margin-bottom:20px;"]);
	
	var SectionHeaderCopy = /*#__PURE__*/_styledComponents2.default.p.withConfig({
	  displayName: "SectionHeaderContent__SectionHeaderCopy"
	})(["margin-bottom:40px;@media (max-width:480px){margin-bottom:10px;}"]);
	
	var SectionHeaderContent = function SectionHeaderContent(props) {
	  return _react2.default.createElement(
	    SectionHeaderWrapper,
	    null,
	    _react2.default.createElement(_HeaderConvo2.default, { name: props.name }),
	    _react2.default.createElement(
	      SectionHeaderContentWrapper,
	      null,
	      _react2.default.createElement(
	        SectionHeaderHeadline,
	        null,
	        props.headline
	      ),
	      _react2.default.createElement(
	        SectionHeaderCopy,
	        null,
	        props.copy
	      ),
	      _react2.default.createElement(_AddtoSlack2.default, null)
	    )
	  );
	};
	
	exports.default = SectionHeaderContent;
	module.exports = exports["default"];

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionIllustrationWrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: "SectionIllustration__SectionIllustrationWrapper"
	})(["display:flex;align-items:center;position:relative;z-index:", ";left:", ";transform:", ";margin:0 auto;width:", ";@media (max-width:1100px){}@media (max-width:900px){width:60%;}@media (max-width:768px){width:", ";}@media screen and (max-width:420px){width:100%;}"], function (props) {
	  return props.zIndex;
	}, function (props) {
	  return props.position;
	}, function (props) {
	  return props.transform;
	}, function (props) {
	  return props.bigIllustration ? "70%" : "50%";
	}, function (props) {
	  return props.isChat ? "80%" : "100%";
	});
	
	var SectionIllustration = function SectionIllustration(props) {
	  return _react2.default.createElement(
	    SectionIllustrationWrapper,
	    {
	      bigIllustration: props.bigIllustration,
	      transform: props.transform,
	      position: props.position,
	      zIndex: props.zIndex },
	    _react2.default.createElement("img", { src: props.name })
	  );
	};
	
	exports.default = function (_ref) {
	  var name = _ref.name,
	      position = _ref.position,
	      transform = _ref.transform,
	      bigIllustration = _ref.bigIllustration,
	      zIndex = _ref.zIndex;
	  return _react2.default.createElement(SectionIllustration, {
	    bigIllustration: bigIllustration,
	    name: name,
	    transform: transform,
	    position: position,
	    zIndex: zIndex
	  });
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 322:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 323:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(78);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(71);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(322);
	
	__webpack_require__(323);
	
	var _SectionOneBackground = __webpack_require__(499);
	
	var _SectionOneBackground2 = _interopRequireDefault(_SectionOneBackground);
	
	var _SectionTwoBackground = __webpack_require__(500);
	
	var _SectionTwoBackground2 = _interopRequireDefault(_SectionTwoBackground);
	
	var _SectionThreeBackground = __webpack_require__(136);
	
	var _SectionThreeBackground2 = _interopRequireDefault(_SectionThreeBackground);
	
	var _SectionFourBackground = __webpack_require__(498);
	
	var _SectionFourBackground2 = _interopRequireDefault(_SectionFourBackground);
	
	var _SectionFiveBackground = __webpack_require__(497);
	
	var _SectionFiveBackground2 = _interopRequireDefault(_SectionFiveBackground);
	
	var _SectionCalloutBackground = __webpack_require__(496);
	
	var _SectionCalloutBackground2 = _interopRequireDefault(_SectionCalloutBackground);
	
	var _slackMeetSmallchat = __webpack_require__(508);
	
	var _slackMeetSmallchat2 = _interopRequireDefault(_slackMeetSmallchat);
	
	var _customerChat = __webpack_require__(505);
	
	var _customerChat2 = _interopRequireDefault(_customerChat);
	
	var _HeaderConversation = __webpack_require__(503);
	
	var _HeaderConversation2 = _interopRequireDefault(_HeaderConversation);
	
	var _SectionCallout = __webpack_require__(58);
	
	var _SectionCallout2 = _interopRequireDefault(_SectionCallout);
	
	var _ArticleCard = __webpack_require__(85);
	
	var _ArticleCard2 = _interopRequireDefault(_ArticleCard);
	
	var _SectionCenteredContent = __webpack_require__(228);
	
	var _SectionCenteredContent2 = _interopRequireDefault(_SectionCenteredContent);
	
	var _HomeFeatureSet = __webpack_require__(226);
	
	var _HomeFeatureSet2 = _interopRequireDefault(_HomeFeatureSet);
	
	var _SectionBlockContent = __webpack_require__(88);
	
	var _SectionBlockContent2 = _interopRequireDefault(_SectionBlockContent);
	
	var _SectionIllustration = __webpack_require__(90);
	
	var _SectionIllustration2 = _interopRequireDefault(_SectionIllustration);
	
	var _SectionHeaderContent = __webpack_require__(229);
	
	var _SectionHeaderContent2 = _interopRequireDefault(_SectionHeaderContent);
	
	var _SectionBackground = __webpack_require__(57);
	
	var _SectionBackground2 = _interopRequireDefault(_SectionBackground);
	
	var _SectionContainer = __webpack_require__(89);
	
	var _SectionContainer2 = _interopRequireDefault(_SectionContainer);
	
	var _withScreensize = __webpack_require__(59);
	
	var _withScreensize2 = _interopRequireDefault(_withScreensize);
	
	var _ScreensizeProvider = __webpack_require__(87);
	
	var _ScreensizeProvider2 = _interopRequireDefault(_ScreensizeProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pageData = {
	  headline: "Talk to your visitors without leaving Slack.",
	  copy: "Start conversations with visitors on your website through Smallchat and convert those visitors into customers. All from inside Slack.",
	
	  slackHeadline: "Smallchat + Slack.",
	  slackCopy: "Smallchat runs inside your Slack team, which means no additional software to learn. Be available to chat with visitors on your website and your team members all in one place. Each conversation creates a new thread, allowing your team to manage it all from one place.",
	  slackProTip: "Pro Tip: With Smallchat Pro, you can add additional sites in their own channel.",
	
	  customerHeadline: "Customer chat simplified.",
	  customerCopy: "With Smallchat there’s no need to add another piece of software to your workflow. Bring all your communication together in Slack.",
	  customerProTip: "",
	
	  statTitle: "Add your voice to the 50,000 conversations happening on Smallchat.",
	  statDescription: "Completely customizable for any brand, any platform & any language.",
	
	  homeFeatureTitle: "All the features you expect.",
	
	  HomeFeatureSet: [{
	    iconName: "contactList",
	    featureName: "Contact List",
	    featureDescription: "Quickly and easily view your customer information or export a CSV to your favorite email platform."
	  }, {
	    iconName: "easyInstall",
	    featureName: "Easily Install",
	    featureDescription: "Add a single embed script to your site. Tweak some settings, and your widget updates automatically.",
	    featureLink: "https://stories.nicer.io/smallchat-on-shopify-44925d05d73e",
	    featureLinkText: "Using Shopify?"
	  }, {
	    iconName: "customizable",
	    featureName: "Fully Customizable",
	    featureDescription: "Customize Smallchat with easy styling that lets you seamlessly integrate with your brand.",
	    featureLink: "https://docs.small.chat/configuration",
	    featureLinkText: "More Customization Tips"
	  }, {
	    iconName: "autoMessages",
	    featureName: "Auto Messages",
	    featureDescription: "Get the conversation started! Actively engage visitors with custom trigger messages.",
	    featureLink: "https://docs.small.chat/automessages",
	    featureLinkText: "Read More"
	  }, {
	    iconName: "editMessages",
	    featureName: "Instant Message Editing",
	    featureDescription: "No need to fret over typos. Edit or delete messages even after they've been sent.",
	    featureLink: "https://stories.nicer.io/slacks-tips-we-use-at-smallchat-ad6c47a50db0",
	    featureLinkText: "Learn More Slack Tips"
	  }, {
	    iconName: "analytics",
	    featureName: "Conversation Analytics",
	    featureDescription: "Track the number of interactions you're getting month to month. To see how your business is performing."
	  }],
	
	  ArticleSet: [{
	    iconName: "autoMessages",
	    articleName: "Why You Should Use Auto Messages",
	    articleDescription: "Get conversations started! Engage visitors with custom trigger messages.",
	    articleLink: "https://docs.small.chat/automessages",
	    articleLinkText: "Read More"
	  }, {
	    iconName: "slack",
	    articleName: "Slack Tips We Use at Smallchat",
	    articleDescription: "Get the most out of your Slack + Smallchat experience with these helpful tips.",
	    articleLink: "https://stories.nicer.io/slacks-tips-we-use-at-smallchat-ad6c47a50db0",
	    articleLinkText: "Read Article"
	  }]
	};
	
	function Home(_ref) {
	  var screensize = _ref.screensize;
	
	  var isMobile = screensize === "phone";
	  var isTablet = screensize === "tablet";
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: "Smallchat \u2014 Connect with your visitors." }),
	    _react2.default.createElement(
	      _SectionContainer2.default,
	      { height: isMobile ? "90vh" : isTablet ? "90vh" : "80vh" },
	      _react2.default.createElement(_SectionHeaderContent2.default, {
	        name: _HeaderConversation2.default,
	        headline: pageData.headline,
	        copy: pageData.copy
	      }),
	      _react2.default.createElement(_SectionBackground2.default, {
	        background: _SectionOneBackground2.default,
	        backgroundWidth: isMobile ? "120%" : isTablet ? "110%" : "100%",
	        backgroundHeight: "100%",
	        backgroundRight: "35%",
	        backgroundScale: isMobile ? "1.5" : isTablet ? "1.2" : "1"
	      })
	    ),
	    _react2.default.createElement(
	      _SectionContainer2.default,
	      { height: isMobile ? "90vh" : isTablet ? "70vh" : "80vh" },
	      _react2.default.createElement(_SectionBlockContent2.default, {
	        headline: pageData.slackHeadline,
	        copy: pageData.slackCopy,
	        protips: pageData.slackProTip
	      }),
	      _react2.default.createElement(_SectionIllustration2.default, {
	        transform: isMobile ? "scale(.6)" : isTablet ? "scale(.8)" : "scale(1)",
	        position: isMobile ? "-40%" : isTablet ? "0%" : "0%",
	        name: _slackMeetSmallchat2.default
	      }),
	      _react2.default.createElement(_SectionBackground2.default, {
	        background: _SectionTwoBackground2.default,
	        backgroundWidth: isMobile ? "180%" : isTablet ? "140%" : "100%",
	        backgroundHeight: "100%",
	        backgroundRight: "-5%",
	        backgroundScale: isMobile ? "1.6" : isTablet ? "1.4" : "1.2"
	      })
	    ),
	    _react2.default.createElement(
	      _SectionContainer2.default,
	      {
	        height: isMobile ? "120vh" : isTablet ? "95vh" : "75vh" },
	      _react2.default.createElement(_HomeFeatureSet2.default, {
	        title: pageData.homeFeatureTitle,
	        features: pageData.HomeFeatureSet
	      }),
	      _react2.default.createElement(_SectionBackground2.default, {
	        background: _SectionThreeBackground2.default,
	        backgroundWidth: "100%",
	        backgroundHeight: isMobile ? "40%" : isTablet ? "60%" : "100%",
	        backgroundRight: "35%",
	        backgroundScale: isMobile ? "1.5" : isTablet ? "1.2" : "1"
	      })
	    ),
	    _react2.default.createElement(
	      _SectionContainer2.default,
	      { height: isMobile ? "50vh" : isTablet ? "50vh" : "50vh" },
	      _react2.default.createElement(_SectionBlockContent2.default, {
	        headline: pageData.customerHeadline,
	        copy: pageData.customerCopy,
	        protips: pageData.customerProTip
	      }),
	      _react2.default.createElement(_SectionIllustration2.default, {
	        zIndex: "10",
	        name: _customerChat2.default,
	        transform: isMobile ? "scale(.5)" : isTablet ? "scale(.7)" : "scale(.9)",
	        position: isMobile ? "-12%" : isTablet ? "10%" : "-5%"
	      }),
	      _react2.default.createElement(_SectionBackground2.default, {
	        background: _SectionFourBackground2.default,
	        backgroundWidth: isMobile ? "150%" : isTablet ? "90%" : "100%",
	        backgroundHeight: isMobile ? "70%" : isTablet ? "90%" : "100%",
	        backgroundRight: isMobile ? "-40%" : isTablet ? "0%" : "-10%",
	        backgroundScale: isMobile ? "1.7" : isTablet ? "1.6" : "1.3"
	      })
	    ),
	    _react2.default.createElement(
	      _SectionContainer2.default,
	      {
	        height: isMobile ? "100vh" : isTablet ? "100vh" : "90vh" },
	      _react2.default.createElement(
	        _SectionCenteredContent2.default,
	        {
	          headline: pageData.statTitle,
	          copy: pageData.statDescription },
	        _react2.default.createElement(_ArticleCard2.default, { articles: pageData.ArticleSet })
	      ),
	      _react2.default.createElement(_SectionBackground2.default, {
	        background: _SectionFiveBackground2.default,
	        backgroundHeight: isMobile ? "40%" : isTablet ? "50%" : "150%",
	        backgroundWidth: isMobile ? "100%" : isTablet ? "80%" : "100%",
	        backgroundRight: "0%",
	        backgroundScale: isMobile ? "3" : isTablet ? "3" : "1.1"
	      })
	    ),
	    _react2.default.createElement(_SectionCallout2.default, {
	      darkShadow: true,
	      background: _SectionCalloutBackground2.default,
	      backgroundSize: "cover",
	      backgroundPosition: "80% 80%",
	      title: "Start your conversations today."
	    })
	  );
	}
	
	exports.default = (0, _withScreensize2.default)(Home);
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-9040b7f341f4b64aa55f.js